module.exports = __webpack_public_path__ + "static/media/qa.e1c7c519.svg";